import { Helmet } from 'react-helmet-async';
import ConversionsAnalysis from 'src/sections/overview/dashboards/views/conversionsAnalysis';

export default function SearchPerformanceConversionsAnalysis() {
  return (
    <>
      <Helmet>
        <title>Conversions Analysis</title>
      </Helmet>

      <ConversionsAnalysis />
    </>
  );
}
